import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { lighten, makeStyles } from '@material-ui/core/styles';
import BlockIcon from '@material-ui/icons/Block';
import get from 'lodash/get';
import { colors } from '../../constants/styleConstants';
import { dateFormats } from '../../constants/consts';

const useStyles = makeStyles(theme => ({
  monthBlock: {
    display: 'flex',
    flexDirection: 'row',
  },
  month: {
    fontSize: 14,
    textTransform: 'uppercase',
    paddingRight: '9px',
    opacity: 0.5,
    color: '#2d2e31',
    [theme.breakpoints.down('xs')]: {
      paddingRight: '6px',
    },
  },

  date: {
    position: 'relative',
    fontSize: '14px',
    fontWeight: 'bold',
    paddingRight: '9px',
    color: colors.black,
    [theme.breakpoints.down('xs')]: {
      paddingRight: '6px',
    },
  },
  cancelled: {
    position: 'absolute',
    top: '-5px',
    left: '-4px',
    fontSize: '24px',
    color: colors.blockIcon,
    opacity: 0.7,
  },
  artistDates: {
    color: colors.orange2,
    textDecorationThickness: '3px',
    fontWeight: 'bold',
  },
  fullCancelled: {
    textDecoration: 'line-through',
  },
  typeLetter: {
    fontSize: '14px',
    fontStyle: 'italic',
    fontWeight: 'normal',
  },
  past: {
    color: colors.grey1,
  },
  pastPerformed: {
    color: lighten(colors.primary, 0.5),
  },
}));

const DateBlock = ({ className, dates, title, linkProps, isCancelled }) => {
  const classes = useStyles();
  return (
    <span className={classNames(classes.dates, className)}>
      <span className={classes.month}>{title}</span>
      {dates.map((date, index) => {
        const momentDate = get(date, 'date');
        const past = get(date, 'past');
        const cancelled = get(date, 'cancelled', false);
        const partialCancelled = get(date, 'partialCancelled', false);
        const matinee = get(date, 'matinee', false);
        const tour = get(date, 'tour', false);
        const performed = get(date, 'performed', false);
        const link = linkProps ? { ...linkProps } : null;
        if (link) link.as = `${link.as}?date=${get(date, 'date._i')}`;
        // eslint-disable-next-line no-nested-ternary
        return momentDate ? (
          <span key={`${momentDate.format(dateFormats.basic)}-${index}`}>
            <span
              className={classNames(classes.date, {
                [classes.fullCancelled]: cancelled || isCancelled,
                [classes.artistDates]: performed && !past,
                [classes.past]: past && !performed,
                [classes.pastPerformed]: past && performed,
              })}
            >
              {partialCancelled && <BlockIcon className={classes.cancelled} />}
              {momentDate.format('DD')}
              {matinee && <span className={classes.typeLetter}>m</span>}
              {tour && <span className={classes.typeLetter}>t</span>}
            </span>
          </span>
        ) : null;
      })}
    </span>
  );
};

DateBlock.propTypes = {
  dates: PropTypes.array,
  title: PropTypes.string,
  className: PropTypes.string,
};

DateBlock.defaultProps = {
  title: '',
};

export default DateBlock;
